export let openMapAddress = '';
if (process.env.NODE_ENV?.endsWith('.local')) {
  openMapAddress = 'http://localhost:5173';
} else if (process.env.NODE_ENV?.startsWith('development')) {
  openMapAddress = 'https://dev.map.clarity.io';
} else if (process.env.NODE_ENV === 'release') {
  openMapAddress = 'https://rls.map.clarity.io';
} else if (process.env.NODE_ENV === 'production') {
  openMapAddress = 'https://map.clarity.io';
}
